import React, { useEffect } from 'react'
import fetch from 'cross-fetch'
import { useQuery } from 'react-query'
import { usePersistedState } from '../hooks/use-persisted-state'
import { Container, Segment, Icon, Header } from 'semantic-ui-react'
import ReactMarkdown from 'react-markdown'

import './WhatsNewApp.scss'

import CrmListMd from '../cms/md/3a52c00be0b740fd84fa32f57aed5964.md';
import CrmList2Md from '../cms/md/49d1a1083c8b44febc1b96d474b0564d.md';
import OctoberMd from '../cms/md/october.md';
import OmnisearchMd from '../cms/md/omnisearch.md';
import AprilMd from '../cms/md/april.md';

const badge = 1;
const content = [{
  key: AprilMd,
  releaseDate: 'Apr 27, 2021',
  headline: 'What\'s new with GOEnforce?'
},{
  key: OmnisearchMd,
  releaseDate: 'Nov 05, 2020',
  headline: 'Introducing Omni-Search',
},{
  key: OctoberMd,
  releaseDate: 'Oct 29, 2020',
  headline: 'What\'s New - October 2020',
},{
  key: CrmList2Md,
  releaseDate: 'Sept 23, 2020',
  headline: "2020 - Sept 23 Release Notes",
},{
  key: CrmListMd,
  releaseDate: 'Sept 14, 2020',
  headline: "We've built a brand new way to navigate your workflow",
}]

export const useWhatsNew = () => {
  const now = Date.now()
  const [dismissed, setDismissedAt] = usePersistedState('notifications.whats-new.dismissedAt', 0)
  const lastUpdated = Date.parse(content[0].releaseDate)
  const shouldShowBadge = 
    now - lastUpdated > 0 &&
    (
      now - lastUpdated < 172800 ||
      lastUpdated > dismissed
    )

  return {
    lastUpdated,
    badge,
    shouldShowBadge,
    setDismissedAt
  }
}

export const WhatsNewApp = () => {
  const [, setDismissedAt] = usePersistedState('notifications.whats-new.dismissedAt', 0)
  useEffect(() => {
    setDismissedAt(Date.now())
  }, [])
  return (
    <Segment basic>
      <div className="WhatsNewApp">
        {
          content.map((article) => {
            const query = useQuery(article.key, () => fetch(article.key).then(r => r.text()))
            return (
              <>
                <Header as={'h1'} dividing>
                  <Icon name="lightning" circular color="yellow"/>
                  <Header.Content>
                    {article.headline}
                    <Header.Subheader>{article.releaseDate}</Header.Subheader>
                  </Header.Content>
                </Header>
                <Container>
                  { query.data && <ReactMarkdown source={query.data} />}
                </Container>
              </>
            )
          })
        }
      </div>
    </Segment>
  )
}

export default WhatsNewApp
